document.addEventListener("DOMContentLoaded", function () {
  var tabGroups = document.querySelectorAll("[data-pelvic-health-tabs]");

  tabGroups.forEach(function (group) {
    var tabs = group.querySelectorAll("[data-pelvic-health-tab]");
    var panels = group.querySelectorAll("[data-pelvic-health-panel]");
    var mobileMedia = window.matchMedia("(max-width: 768px)");
    var statCards = group.querySelectorAll(".pelvic-health-section__stat-card");

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var target = tab.getAttribute("data-pelvic-health-tab");

        tabs.forEach(function (currentTab) {
          var isActive = currentTab === tab;
          currentTab.classList.toggle("pelvic-health-section__tab--active", isActive);
          currentTab.setAttribute("aria-selected", isActive ? "true" : "false");
        });

        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute("data-pelvic-health-panel") !== target;
        });

        statCards.forEach(function (card) {
          card.classList.remove("pelvic-health-section__stat-card--flipped");
        });
      });
    });

    statCards.forEach(function (card) {
      card.addEventListener("click", function () {
        card.classList.toggle("pelvic-health-section__stat-card--flipped");
      });
    });

    var clearFlippedCards = function (event) {
      if (event && event.matches) {
        return;
      }

      statCards.forEach(function (card) {
        card.classList.remove("pelvic-health-section__stat-card--flipped");
      });
    };

    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener("change", clearFlippedCards);
    } else if (mobileMedia.addListener) {
      mobileMedia.addListener(clearFlippedCards);
    }
  });

  var carouselViewports = document.querySelectorAll("[data-fitness-carousel-viewport]");

  carouselViewports.forEach(function (viewport) {
    var carousel = viewport.closest(".fitness-carousel");
    var previousButton = carousel && carousel.querySelector("[data-fitness-carousel-prev]");
    var nextButton = carousel && carousel.querySelector("[data-fitness-carousel-next]");
    var cards = Array.prototype.slice.call(viewport.querySelectorAll(".fitness-carousel__card"));

    if (!carousel || !previousButton || !nextButton || !cards.length) {
      return;
    }

    var getCurrentCardIndex = function () {
      var scrollLeft = viewport.scrollLeft;
      var closestIndex = 0;
      var closestDistance = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(card.offsetLeft - scrollLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    var scrollToCard = function (index) {
      var targetIndex = Math.max(0, Math.min(cards.length - 1, index));
      var targetLeft = targetIndex === 0 ? 0 : cards[targetIndex].offsetLeft;

      viewport.scrollTo({
        left: targetLeft,
        behavior: "smooth",
      });
    };

    previousButton.addEventListener("click", function () {
      scrollToCard(getCurrentCardIndex() - 1);
    });

    nextButton.addEventListener("click", function () {
      scrollToCard(getCurrentCardIndex() + 1);
    });
  });

});
